import { useState, useCallback, useEffect } from "react";
import { toast } from "react-toastify";
import { PAYMENT_SERVICE_BASE_URL } from "constants";
import apiClient from "utils/apiClient";

const OUTGOING_URL = `${PAYMENT_SERVICE_BASE_URL}/api/v1/payments/methods`;
const INCOMING_URL = `${PAYMENT_SERVICE_BASE_URL}/api/v1/payments/external/accounts/active`;

export default function usePaymentMethods(userId) {
  const authToken = sessionStorage.getItem("authToken");
  const [outgoingMethods, setOutgoingMethods] = useState([]);
  const [incomingAccounts, setIncomingAccounts] = useState([]);
  const [connectAccount, setConnectAccount] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchFinancialProfile = useCallback(async () => {
    if (!userId) return;
    setLoading(true);
    setError(null);

    try {
      const [outgoingRes, incomingRes] = await Promise.all([
        apiClient.get(`${OUTGOING_URL}?uid=${userId}&page=0&size=50`),
        apiClient.get(`${INCOMING_URL}?uid=${userId}`),
      ]);

      const outgoingContent = outgoingRes.data?.content || [];
      const incomingContent = incomingRes.data || [];

      setOutgoingMethods(outgoingContent);
      setIncomingAccounts(incomingContent);
      setConnectAccount(
        outgoingContent.find((item) => item?.connectAccount)?.connectAccount ||
          incomingContent.find((item) => item?.connectAccount)?.connectAccount ||
          null,
      );
    } catch (err) {
      const message = err.response?.data?.message || "Failed to load profile";
      setError(message);
      toast.error(message);
    } finally {
      setLoading(false);
    }
  }, [userId]);

  useEffect(() => {
    if (authToken && userId) fetchFinancialProfile();
  }, [authToken, userId, fetchFinancialProfile]);

  return {
    outgoingMethods,
    incomingAccounts,
    connectAccount,
    loading,
    error,
    refresh: fetchFinancialProfile,
  };
}
